export default __webpack_public_path__ + "static/media/RTA_NAV.822b2c1b.png";